import React, { useMemo } from "react";
import bbobReactRender from "@bbob/react/es/render";
import presetReact from "@bbob/preset-react";
import { bool, func, arrayOf, object } from "prop-types";

import Typography from "../shared/Typography";
import Modal from "../shared/Modal";

import { getParsedLegalMention } from "@shared/v2/lib/getParsedLegalMention";
import { useTranslation } from "@lib/i18n";

const LegalMentionModal = ({ isOpen, onClose, legalMention }) => {
  const { t } = useTranslation();

  const parsedLegalMentions = useMemo(() => {
    return getParsedLegalMention(legalMention);
  }, [legalMention]);

  return (
    <Modal
      isOpen={isOpen}
      withCloseIcon
      ariaLabel={t("basket.financing.legalMention")}
      onClose={onClose}
    >
      <div className="p-4 pt-6 flex flex-col gap-2 w-full">
        {parsedLegalMentions.map((text, index) => (
          <Typography className="text-sm my-2" key={index}>
            {bbobReactRender(text, presetReact(), {
              onlyAllowTags: ["url", "b"],
            })}
          </Typography>
        ))}
      </div>
    </Modal>
  );
};

LegalMentionModal.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  legalMention: arrayOf(object).isRequired,
};

export default LegalMentionModal;
